/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

export const REQUEST_INCENTIVES = 'REQUEST_INCENTIVES';
export const REQUEST_INCENTIVES_SUCCESS = 'REQUEST_INCENTIVES_SUCCESS';
export const REQUEST_INCENTIVES_FAILURE = 'REQUEST_INCENTIVES_FAILURE';

export const REQUEST_INCENTIVES_PROSES = 'REQUEST_INCENTIVES_PROSES';
export const REQUEST_INCENTIVES_PROSES_SUCCESS = 'REQUEST_INCENTIVES_PROSES_SUCCESS';
export const REQUEST_INCENTIVES_PROSES_FAILURE = 'REQUEST_INCENTIVES_PROSES_FAILURE';

export const REQUEST_INCENTIVE = 'REQUEST_INCENTIVE';
export const REQUEST_INCENTIVE_SUCCESS = 'REQUEST_INCENTIVE_SUCCESS';
export const REQUEST_INCENTIVE_FAILURE = 'REQUEST_INCENTIVE_FAILURE';

export const REQUEST_ADD_INCENTIVE = 'REQUEST_ADD_INCENTIVE';
export const REQUEST_ADD_INCENTIVE_SUCCESS = 'REQUEST_ADD_INCENTIVE_SUCCESS';
export const REQUEST_ADD_INCENTIVE_FAILURE = 'REQUEST_ADD_INCENTIVE_FAILURE';

export const REQUEST_PRINT_INCENTIVE = 'REQUEST_PRINT_INCENTIVE';
export const REQUEST_PRINT_INCENTIVE_FAILURE = 'REQUEST_PRINT_INCENTIVE_FAILURE';
export const REQUEST_PRINT_INCENTIVE_SUCCESS = 'REQUEST_PRINT_INCENTIVE_SUCCESS';

export const REQUEST_INCENTIVE_REPORT = 'REQUEST_INCENTIVE_REPORT';
export const REQUEST_INCENTIVE_REPORT_FAILURE = 'REQUEST_INCENTIVE_REPORT_FAILURE';
export const REQUEST_INCENTIVE_REPORT_SUCCESS = 'REQUEST_INCENTIVE_REPORT_SUCCESS';

export const REQUEST_SEND_WA = 'REQUEST_SEND_WA';
export const REQUEST_SEND_WA_SUCCESS = 'REQUEST_SEND_WA_SUCCESS';
export const REQUEST_SEND_WA_FAILURE = 'REQUEST_SEND_WA_FAILURE';
